// As of 2024-02-3 we are either accepting HTML content or PDF content to print documents.
// Interface will allow HTML or PDF content to be passed to the print service for testing. 

import { Policy } from "cockatiel";

export enum FormSystem {
	DocProd = 'DocProd',
	GhostDraft = 'GhostDraft'
} 

export class PolicyFormsTracker {
	// Cosmos DB unique id
	id: string;

	// Cosmos DB partition key
	policyNumber: string;

	amendmentNumber: number | null = null;

	correlationId: string;
	policySnapshotId?: string | null = null;
	requestedBy: string;
	createdBy: string;
	dateStarted: Date = new Date();
	dateFinished?: Date;

	// Signifies that all interactive forms have been completed by the user and the 'submit' button has been clicked.
	hasInteractiveForms: boolean;

	// Signifies that the interactive forms (pdfs) have been generated and stored
	interactiveFormsGenerated: boolean;

	// Signifies that there are policy forms to generate
	hasPolicyForms: boolean;

	// Signifies that the policy forms (pdfs) have been generated and stored
	policyFormsGenerated: boolean;

	// Signifies that document rules have been executed
	documentRulesExecuted: boolean;

	// Signifies that documents have been blended
	documentsBlended: boolean;

	policyForms: PolicyFormDetails[] = [];

	isCompleted: boolean;

	isBatch: boolean;

}

export class InteractiveFormsReady {
	documentId: string;
}

export class PolicyFormsGenerated {
	documentId: string;
}

export class StatusUpdate {
	message: string;
	percentComplete: number;
}

export class FormGenerationStartedNotification {
	documentId: string;
	policyNumber: string;
	formName: string;
}

export class FormGeneratedNotification {
	documentId: string;
	policyNumber: string;
	formName: string;
}

export class GhostDraftForm {
	name?: string;
	isInteractive: boolean;
	formGenerationStatus: FormGenerationStatus | null;
	serverXml: string;
}

export class PolicyFormDetails {
	sortOrder?: number;
	formCode: string;
	formName: string;
	formEditionDate?: Date | null;
	isInteractive?: boolean | null = false;
	isStatic?: boolean | null = false;
	formSystem?: FormSystem | null = FormSystem.DocProd;
	recipients?: string[] | null;
	transactionTypes?: string[] | null;
	actionCodes?: string[] | null;
	ghostDraftCompany?: string | null;
	ghostDraftDocumentServiceName?: string | null;
	ghostDraftPackageName?: string | null;
	ghostDraftPackageVersion?: string | null;
	ghostDraftFormName?: string | null;
	formGenerationStatus: FormGenerationStatus | null;
	serverXml?: string | null;

	constructor(init?: Partial<PolicyFormDetails>) {
		Object.assign(this, init);
	}
}

export class FormGenerationStatus {
	errorMessage?: string;
	isGenerated?: boolean | null;
	dateStarted?: Date | null;
	dateCompleted?: Date | null;
}

export class DocumentStorageConfig {
	storageAccountUri: string;
	containerName: string;
	path: string;
	sasToken: string;
}

export class DocumentsReadyResponse {
	tracker: PolicyFormsTracker;
	storageConfig: DocumentStorageConfig;
}

export class ViewFormDetailsResponse {
	documentUrl: string;
	formName: string;
}